import React, { ForwardedRef, forwardRef, memo, PropsWithChildren, ReactElement, Ref } from 'react';
import { VirtualizedDataTable as New } from './VirtualizedDataTable';
import { convertOldVirtualizedDataTableProps, OldVirtualizedDataTableProps } from './converter.old';

export type VirtualizedDataTableProps<T> = OldVirtualizedDataTableProps<T>;
export const VirtualizedDataTable = memo(
  forwardRef(<T extends object>(props: VirtualizedDataTableProps<T>, ref: ForwardedRef<HTMLTableElement>) => (
    <New {...convertOldVirtualizedDataTableProps(props)} ref={ref} />
  )),
) as <T extends object>(
  p: PropsWithChildren<VirtualizedDataTableProps<T>> & { ref?: Ref<HTMLTableElement> },
) => ReactElement;

(VirtualizedDataTable as typeof VirtualizedDataTable & { displayName?: string }).displayName = 'VirtualizedDataTable';
